module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_sneaker_f691303ff88fc332df9b1136cb5f0ded.png";